import { Spin } from 'antd';
import { useState } from 'react';
import { ILineDetail } from '../../entities/farms.entities';
import { ICycleResource } from '../../entities/growing.entities';
import { translate } from '../../lib/lang.helper';
import { useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { SelectIsFarmable } from '../../store/extra/extra.selector';
import { Button, Subtitle } from '../../components/shared';
import { amountDays } from '../../lib/common.helpers';
import LineSpatModal from '../../components/lines/LineSpatModal';
import LineBioModal from '../../components/lines/LineBioModal';

interface Props {
  lineData: ILineDetail;
  cyclePart: ICycleResource | null;
  checkedHistoryView: number;
  onHistoryViewClick: () => void;
  onFloatingManageClick: () => void;
  onMaintenanceClick: () => void;
  onExtraSeedClick: () => void;
  onAssessmentClick: () => void;
  onCatchSpatClick: () => void;
  onSeedingClick: () => void;
  loadLine: () => void;
  showLineSpat?: boolean;
  setShowLineSpat?: (show: boolean) => void;
}

const LineManageButtonsView = ({
  lineData,
  cyclePart,
  checkedHistoryView,
  onHistoryViewClick,
  onAssessmentClick,
  onCatchSpatClick,
  onExtraSeedClick,
  onFloatingManageClick,
  onMaintenanceClick,
  onSeedingClick,
  loadLine,
  showLineSpat,
  setShowLineSpat,
}: Props) => {
  const lang = useSelector(selectLang);
  const isFarmable = SelectIsFarmable(lineData.farm_id);

  const [showLineBio, setShowLineBio] = useState(false);

  const mainSeed = cyclePart?.main_seed;

  return (
    <div className='d-flex justify-between align-center white-card pt-12 pr-16 pb-12 mb-8'>
      {mainSeed || lineData.seedings.length > 0 ? (
        <button
          className={`timeline-button${
            checkedHistoryView === 1 ? ' --checked' : ''
          }`}
          onClick={onHistoryViewClick}
        >
          {checkedHistoryView === -1 ? (
            <div className='ml-17 mr-17'>
              <Spin />
            </div>
          ) : (
            translate(
              lang,
              checkedHistoryView === 1 ? 'Hide history' : 'Show history',
            )
          )}
        </button>
      ) : (
        <span></span>
      )}
      {isFarmable && (
        <div className='d-flex justify-end'>
          {mainSeed ? (
            <>
              {mainSeed.is_growing ? (
                <>
                  <Button
                    className='mr-10'
                    color='blue'
                    size={1}
                    width='middle'
                    type='fill'
                    onClick={onFloatingManageClick}
                  >
                    {translate(lang, 'Inventory Management')}
                  </Button>
                  <Button
                    className='mr-10'
                    color='green'
                    size={1}
                    width='middle'
                    type='fill'
                    onClick={onMaintenanceClick}
                  >
                    {translate(lang, 'Add maintenance')}
                  </Button>
                  {!mainSeed.is_catch_spat && (
                    <Button
                      className='mr-10'
                      color='blue'
                      size={1}
                      width='middle'
                      type='fill'
                      onClick={onExtraSeedClick}
                    >
                      {translate(lang, 'Add extra seed')}
                    </Button>
                  )}
                  <Button
                    className='mr-10'
                    color='green'
                    size={1}
                    width='middle'
                    type='fill'
                    onClick={onAssessmentClick}
                  >
                    {translate(lang, 'Add assessment')}
                  </Button>
                  <Button
                    color='orange'
                    size={1}
                    width='middle'
                    type='fill'
                    onClick={() => setShowLineBio(true)}
                  >
                    {translate(lang, 'Environmental')}
                  </Button>
                </>
              ) : (
                <span></span>
              )}
            </>
          ) : (
            <div className='d-flex align-center'>
              <div className='d-flex align-center'>
                <Subtitle size={3} color='black' align='left' fontWeight={400}>
                  {translate(lang, 'Line empty for')}
                </Subtitle>
                <Subtitle
                  size={4}
                  color='black'
                  align='left'
                  fontWeight={600}
                  className='ml-4 mr-27'
                >
                  {amountDays(lineData?.line_idle, lang)}
                </Subtitle>
              </div>
              <Button
                className='mr-8'
                color='blue'
                size={1}
                width='small'
                type='fill'
                onClick={onCatchSpatClick}
              >
                {translate(lang, 'Catch Spat')}
              </Button>
              <Button
                className='mr-8'
                color='blue'
                size={1}
                width='small'
                type='fill'
                onClick={onSeedingClick}
              >
                {translate(lang, 'Seed the line')}
              </Button>
              <Button
                className='mr-8'
                color='green'
                size={1}
                width='middle'
                type='fill'
                onClick={onMaintenanceClick}
              >
                {translate(lang, 'Add maintenance')}
              </Button>
              <Button
                color='orange'
                size={1}
                width='middle'
                type='fill'
                onClick={() => setShowLineBio(true)}
              >
                {translate(lang, 'Environmental')}
              </Button>
            </div>
          )}
          {setShowLineSpat && showLineSpat && (
            <LineSpatModal
              visible={showLineSpat}
              title={translate(lang, '_line_spat_count_history')}
              lineId={lineData.id}
              onLoadLine={loadLine}
              onClose={() => setShowLineSpat(false)}
            />
          )}
          {showLineBio && (
            <LineBioModal
              lineData={lineData}
              onClose={() => setShowLineBio(false)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default LineManageButtonsView;
